/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_TitleInputs */

const en_fc_home_artcraft_title = /** @type {(inputs: Fc_Home_Artcraft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft FilmCraft and the Crafting Apps`)
};

/**
* | output |
* | --- |
* | "ArtCraft FilmCraft and the Crafting Apps" |
*
* @param {Fc_Home_Artcraft_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_title = /** @type {((inputs?: Fc_Home_Artcraft_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_title(inputs)
});
export { fc_home_artcraft_title as "fc.home.artcraft.title" }